// extracted by mini-css-extract-plugin
module.exports = {"clock":"Clock_clock__3yhIt"};